// @flow
type ErrorShape = {
  stack?: string,
  status?: number,
  statusText?: string,
  description?: string,
  data?: {
    msg?: string,
    status?: string,
    title?: string,
    detail?: string,
  },
  line?: number,
  column?: number,
  sourceURL?: string,
  // SC shape
  Error?: any, // eslint-disable-line flowtype/no-weak-types
}

type Input = ?(ErrorShape | string)

export default function getErrorMessage(err: Input): string {
  if (!err) {
    return "unknown error"
  }

  if (typeof err === "string") {
    return err
  }

  if (err instanceof Error) {
    if (err.data) {
      if (err.data.detail === "price change") {
        return `price_change`
      }

      if (err.data.msg) {
        return err.data.msg
      }
      if (err.data.title && err.data.detail) {
        return `${err.data.title} ${err.data.detail}`
      }
    }
    return err.toString()
  }

  if (err.data && err.data.msg) {
    return err.data.msg
  }

  if (err.statusText) {
    return err.statusText
  }

  // SC shape
  if (err.Error && err.Error.title) {
    return err.Error.title
  }

  return "unknown error"
}
